const helpConfiguration = {
  on_login_screen: "Lien d'aide à afficher sur l'écran de connexion",
  on_dashboard: "Lien d'aide à afficher sur le tableau de bord",
  test_link: 'Tester le lien',
  invalid_format: "Format d'URL invalide",
};

export default helpConfiguration;
